import React from "react";
import { Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { colors } from "../../lib/constant";
import { IconAndroid24, IconIos24 } from "../../icons-ts";
import { Title } from "./Title";
import { fontFamily, fontSize, product_sans } from "../../lib/fonts";
import { mediaQuery } from "react-styled-mediaquery";
import { FormattedMessage } from "react-intl";

const CardPlatform = ({
  icon,
  title,
  desc,
  href,
  target,
}: {
  icon: React.ReactNode;
  title: string | JSX.Element;
  desc: string;
  href: string;
  target: string;
}) => (
  <CardContainer target={target} href={href}>
    <div>{icon}</div>
    <CardTitle>{title}</CardTitle>
    <CardDesc>{desc}</CardDesc>
  </CardContainer>
);

export const CardDevices = () => (
  <Container id="download">
    <TitleCard htmlLevel={2}>
      <FormattedMessage
        id="cardDevices.title"
        defaultMessage="Available on all types of smartphones."
      />
    </TitleCard>
    <Cards>
      <CardPlatform
        target="_blank"
        href="https://apps.apple.com/gb/app/flashix/id1501193802"
        icon={<IconIos24 width="24" fill="#fff" />}
        title={
          <FormattedMessage
            id="cardDevices.on_iphone"
            defaultMessage="On your iPhone"
          />
        }
        desc="iOS"
      />
      <CardPlatform
        target="_blank"
        href="https://play.google.com/store/apps/details?id=be.igloo.flashix&hl=fr_CA"
        icon={<IconAndroid24 width="24" fill="#fff" />}
        title={
          <FormattedMessage
            id="cardDevices.on_android"
            defaultMessage="On your phone"
          />
        }
        desc="Android"
      />
    </Cards>
  </Container>
);

const Container = styled(Row)`
  width: 100%;
  background: linear-gradient(
    315deg,
    ${colors.primary} 0%,
    ${colors.primaryLt} 100%
  );
  margin: 0;
  border-radius: 10px;
  padding: 60px;
  box-shadow: 0 10px 30px 0 rgba(27, 22, 51, 0.2);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  margin-bottom: 100px;

  ${mediaQuery("<=", "819px")`
     padding: 30px;
  `}

  ${mediaQuery("<=", "tablet")`
    padding: 25px 0;
    flex-direction: column;
    margin-bottom: 50px;
  `}

  ${mediaQuery("<=", "phablet")`
    padding: 25px;
  `}
`;

const TitleCard = styled(Title)`
  color: #fff;
  ${fontSize("30px")}
  line-height: 41px;
  ${fontFamily(product_sans.medium)};
  margin-bottom: 0;
  text-align: center;

  ${mediaQuery(">", "tablet")`
    text-align: right;
    margin-right: 30px;
    max-width: 310px;
  `}

  ${mediaQuery("<=", "tablet")`
    ${fontSize("20px")}
    line-height: 28px;
  `}
`;

const CardContainer = styled.a`
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 150px;
  height: 150px;
  padding: 30px;
  box-sizing: border-box;
  margin-left: 30px;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 10px 28px 2px rgba(0, 0, 0, 0.15);
    transform: translateY(-3px);
  }

  ${mediaQuery("<=", "phablet")`
    min-width: auto;
    height: auto;
    padding: 10px;
  `}

  ${mediaQuery("<=", "tablet")`
    display: flex;
    margin-top: 30px;

    &:first-child { margin-left: 0; }
  `}
`;

const CardTitle = styled.div`
  color: #ffffff;
  ${fontFamily(product_sans.medium)};
  ${fontSize("11px")}
  line-height: 15px;
  margin-top: auto;
`;

const CardDesc = styled.div`
  color: #ffffff;
  ${fontFamily(product_sans.bold)};
  ${fontSize("18px")}
  line-height: 24px;
  color: #ffffff;
  margin-top: 5px;
`;

const Cards = styled.div`
  display: flex;
`;
